<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .stat-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: utils.in_rem(18px) utils.in_rem(22px);
    position: relative;
    @include colors.background-color(interfaceSwGrey_5);
    border-radius: 16px;
    gap: utils.in_rem(8px);

    .stat-card-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: utils.in_rem(12px);
    }
  }
</style>

<script>
  export let style = "";
  let cls = "";
  export { cls as class };
</script>

<div class="stat-card {cls}" {style}>
  {#if $$slots.header}
    <slot name="header" />
  {/if}
  <div class="stat-card-container">
    <h1><slot /></h1>
    <slot name="icon" />
  </div>
  {#if $$slots.data}
    <slot name="data" />
  {/if}
</div>
